<template>
  <div class="order-list-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #storeRefId="{ row }">{{ row.storeRefId }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #transactionId="{ row }">{{ row.transactionId }}</template>
      <template #refundOrderId="{ row }">{{ row.refundOrderId }}</template>
      <template #amount="{ row }">{{ row.amount }}</template>
      <template #paymentAmount="{ row }">{{ row.paymentAmount }}</template>
      <template #commitTime="{ row }">{{ row.commitTime ? $moment(row.commitTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>
<script>
import { api_getRefundPage } from '@/api/finance'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "OIndex",
  mixins: [tableList],
  components: {
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "mall",
          key: "mallIds",
        },{
          label: "交易流水号",
          placeholder: "请输入交易流水号",
          type: "input",
          key: "transactionId",
        },
        {
          label: "退款订单号",
          placeholder: "请输入退款订单号",
          type: "input",
          key: "refundOrderId",
        },
        {
          label: "提交时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "created",
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {
        username: "",
        name: "",
      },
      tableThData: [
        { prop: "storeRefId", label: "店铺编号", minWidth: "130", },
        { prop: "mallName", label: "商场名称", minWidth: "150", },
        { prop: "paymentOrderId", label: "订单编号", minWidth: "150", },
        { prop: "transactionId", label: "交易流水号", minWidth: "150", },
        { prop: "refundOrderId", label: "退款订单号", minWidth: "120", },
        { prop: "paymentAmount", label: "订单金额", minWidth: "120", },
        { prop: "amount", label: "退款金额", minWidth: "120", },
        { prop: "commitTime", label: "提交时间", minWidth: "180", },
        { prop: "source", label: "订单来源", minWidth: "180", },
      ]
    };
  },
  created () {
  },
  methods: {

    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.created && newParams.created.length > 0){
        newParams.startTime = +new Date(newParams.created[0])
        newParams.endTime = +new Date(newParams.created[1])
      }
      delete newParams.created
      const data = await api_getRefundPage(newParams)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.order-list-index {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
  }
  .FINISHED{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .DOING{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .REFUNDED{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .CANCELED{
    background: #F74A4A;
    border-radius: 50%;
    vertical-align: middle;
  }
}
</style>
